import RichText from "@/components/RichText";
import { resolveButtonStyle } from "@/lib/ctaButtonStyle";
import CtaButtonBlocks, { ctaButtonBlocks } from "./CtaButtonBlocks";

// Plus sobre que PromoBannerSection : pas d'image, pas de couleur de fond
// libre, pas de second bouton — une phrase et une action. La couleur suit la
// palette du thème (`variant`) plutôt qu'un réglage propre, pour qu'un
// bandeau posé plusieurs fois dans la page reste cohérent avec le reste.
const DEFAULTS = {
  heading: "Parlons de votre projet",
  text: "",
  cta_label: "Nous contacter",
  cta_url: "/#contact",
  variant: "dark",
  anchor_id: "",
};

export default function CtaBannerSection({ props = {}, blocks }) {
  const t = { ...DEFAULTS, ...props };
  const ctaStyle = resolveButtonStyle(t, "cta");
  const extraButtons = ctaButtonBlocks(blocks);
  if (!t.heading && !t.cta_label) return null;

  const dark = t.variant !== "light";
  return (
    <section id={t.anchor_id || undefined} className={`px-6 scroll-mt-28 ${dark ? "bg-ink" : "bg-sand"}`}>
      <div className="max-w-[1240px] mx-auto py-14 md:py-16 flex flex-col items-center text-center gap-4">
        <RichText
          as="h2"
          className={`font-display font-semibold text-[26px] md:text-[32px] leading-tight tracking-[-0.02em] ${dark ? "text-white" : "text-ink"}`}
          html={t.heading}
        />
        {t.text && (
          <p className={`text-[15px] max-w-lg leading-relaxed ${dark ? "text-white/85" : "text-graphite"}`}>{t.text}</p>
        )}
        {(t.cta_label || extraButtons.length > 0) && (
          <div className="flex flex-wrap items-center justify-center gap-4 mt-2">
            {t.cta_label && (
              <a
                href={t.cta_url || "#"}
                className={`inline-flex items-center gap-2 px-7 py-3 text-[14px] font-semibold hover:opacity-90 transition-opacity ${
                  dark ? "bg-white text-ink" : "bg-ink text-white"
                } ${ctaStyle.className}`}
                style={ctaStyle.style}
                aria-label={!ctaStyle.showText ? t.cta_label : undefined}
              >
                {ctaStyle.showIcon && ctaStyle.Icon && <ctaStyle.Icon className="h-4 w-4" />}
                {ctaStyle.showText && t.cta_label}
              </a>
            )}
            <CtaButtonBlocks blocks={extraButtons} tone={dark ? "dark" : "light"} />
          </div>
        )}
      </div>
    </section>
  );
}
